import { messageDate } from '../../utils/sources.js';

// Dump shape: data.workspaces[workspace][channel] = [message]; message.files[] carry blob_url once
// downloaded. Band dumps use workspace "main" / channel "posts".
const workspacesOf = (dump) => {
  const workspaces = dump?.data?.workspaces;
  return workspaces && typeof workspaces === 'object' ? workspaces : null;
};

/** Stable picture id: the hidden-pictures list of a report stores these. */
export const pictureId = (workspace, channel, messageIndex, fileIndex, file) => (
  file.photo_key || file.id || `${workspace}-${channel}-${messageIndex}-${fileIndex}`
);

export const hiddenPictureIds = (report) => (Array.isArray(report?.hidden_pictures?.ids) ? report.hidden_pictures.ids : []);

/** Every downloaded picture of the dump, in channel then message order, with its message context. */
export const collectPictures = (dump) => {
  const workspaces = workspacesOf(dump);
  if (!workspaces) return [];
  const pictures = [];
  Object.entries(workspaces).forEach(([workspace, channels]) => {
    Object.entries(channels || {}).forEach(([channel, messages]) => {
      (Array.isArray(messages) ? messages : []).forEach((message, messageIndex) => {
        (Array.isArray(message?.files) ? message.files : []).forEach((file, fileIndex) => {
          if (!file?.blob_url) return;
          pictures.push({
            ...file,
            imgId: pictureId(workspace, channel, messageIndex, fileIndex, file),
            workspace,
            channel,
            user: message.user,
            username: message.username,
            text: message.text,
            date: messageDate(message.ts),
            filename: file.filename || file.name || 'Photo',
          });
        });
      });
    });
  });
  return pictures;
};

/** Headline figures of a report. Clients only count the pictures they can see. */
export const dumpFacts = (dump, report, isAdminUser) => {
  const workspaces = workspacesOf(dump);
  if (!workspaces) return null;
  let messages = 0;
  const contributors = new Set();
  Object.values(workspaces).forEach((channels) => {
    Object.values(channels || {}).forEach((list) => {
      (Array.isArray(list) ? list : []).forEach((message) => {
        messages += 1;
        if (message?.user) contributors.add(message.user);
      });
    });
  });
  const hidden = new Set(hiddenPictureIds(report));
  const pictures = collectPictures(dump).filter((p) => isAdminUser || !hidden.has(p.imgId)).length;
  return { messages, pictures, contributors: contributors.size };
};
